export default {
    namespaced: true,
    state: {
        user: null,
        userRole:[],
    },
    mutations: {
        initUser: (state,payload) => {
            state.user = payload
        },
        setUser: (state,payload) => {
            state.user = payload
            if(payload) {
                if(payload.data.usrRole) state.userRole = payload.data.usrRole.split(',')
            }
        },
    },
    actions: {
        initUser({commit},payload) {
            commit('initUser',payload)
        },
        setUser({commit},payload) {
            commit('setUser',payload)
        },
    },
    getters: {
        getUser : state => {
            return state.user
        },
        getUserRole: state => {
            return state.userRole
        }
    },
}
